import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Paper } from '@mui/material';
import { liveTrackinglayoutSelector } from '../../features/layout/layoutSlice';
import { Button, ButtonGroup, Divider } from '@mui/material';
import {
    detailViewSelector,
    removeDetailView,
    selectVehicleById
} from '../../features/assets/assetsSlice';
import { userSelector } from '../../features/user/UserSlice';
import { setlayoutLiveTracking } from '../../features/layout/layoutSlice';

import AssetDefaultFooter from './AssetDefaultFooter';
import SensorViewFooter from './SensorViewFooter';
import DeviceViewFooter from './DeviceViewFooter';
import SecurityViewFooter from './SecurityViewFooter';

const AssetFooter = () => {
    const dispatch = useDispatch();
    const dimentions = useSelector(liveTrackinglayoutSelector);
    const [displayType, setDisplayType] = useState('default');
    const assetId = useSelector(detailViewSelector);
    const assetData = useSelector(state => selectVehicleById(state, assetId));
    const user = useSelector(userSelector);
    const { isAdmin } = user;

    useEffect(() => {
        const liveTrackingLayoutPayload = {
            sidebarWidthratio: 0.25,
            minFooter: 80,
        };
        dispatch(setlayoutLiveTracking(liveTrackingLayoutPayload));
    }, [dispatch]);

    if (assetData) {
        const { coreData, sensorData, vehicleDevice, statusMeta } = assetData;
        //console.log("VD", vehicleDevice);
        return (
            <Paper style={{ ...dimentions.footer, }}>
                <Grid
                    container
                    direction='row'
                    justifyContent='space-between'
                    alignItems='flex-start'
                    wrap='wrap'
                    spacing={1}
                    style={{
                        height: '40px',
                        width: '94vw',
                        marginLeft: '5px',
                    }}
                >

                    <Grid item key="Sensors">

                        <div style={{
                            marginTop: '5px',
                            marginBottom: '5px'
                        }}>
                            <Grid
                                container
                                direction='row'
                                justifyContent='flex-start'
                                alignItems='center'
                                alignContent="center"
                                wrap='wrap'
                                spacing={1}
                                style={{
                                    marginLeft: '0px',
                                    width: '90vw',
                                }}
                            >
                                <Grid item key="buttonBlock">
                                    <ButtonGroup variant="text">
                                        <Button variant={displayType === 'default' ? 'contained' : 'text'}
                                            size="small"
                                            style={{
                                                backgroundColor: displayType === 'default' ? statusMeta.colorbg : 'White',
                                                color: displayType === 'default' ? statusMeta.colorfg : statusMeta.colortext,
                                            }}
                                            onClick={() => setDisplayType('default')}>
                                            Status: {vehicleDevice.regn}
                                        </Button>
                                        <Button variant={displayType === 'Sensors' ? 'contained' : 'text'} size="small" color="primary" onClick={() => setDisplayType('Sensors')}>
                                            Sensors
                                        </Button>
                                        <Button variant={displayType === 'Device' ? 'contained' : 'text'} size="small" color="primary" onClick={() => setDisplayType('Device')}>
                                            Device
                                        </Button>
                                        <Button variant={displayType === 'Security' ? 'contained' : 'text'} size="small" color="secondary" onClick={() => setDisplayType('Security')}>
                                            Security
                                        </Button>
                                        <Button variant='text' size="small" color="secondary" onClick={() => dispatch(removeDetailView())}>
                                            Close
                                        </Button>
                                    </ButtonGroup>
                                </Grid>
                                {isAdmin &&
                                    <Grid item key="adminInfo" style={{ marginLeft: 'auto' }}>
                                        <ButtonGroup variant="text" size="small">
                                            <Button
                                                color="primary"
                                                style={{
                                                    textTransform: 'none',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => navigator.clipboard.writeText(assetId)}
                                            >
                                                IMEI: {assetId}
                                            </Button>
                                            <Button
                                                color="primary"
                                                style={{
                                                    textTransform: 'none',
                                                    cursor: 'pointer'
                                                }}
                                                onClick={() => navigator.clipboard.writeText(vehicleDevice.vehicleInfo.sim)}
                                            >
                                                SIM: {vehicleDevice.vehicleInfo.sim}
                                            </Button>
                                            {vehicleDevice.vehicleInfo?.veh_model && <Button
                                                color="primary"
                                                style={{
                                                    textTransform: 'none'
                                                }}
                                            >
                                                Model: {vehicleDevice.vehicleInfo.veh_model}
                                            </Button>}
                                        </ButtonGroup>
                                    </Grid>
                                }
                            </Grid>
                        </div>
                        <Divider />
                        <div style={{ height: '8px' }} />
                        {
                            displayType === 'default' && <AssetDefaultFooter coreData={coreData} statusMeta={statusMeta} />
                        }
                        {
                            displayType === 'Sensors' && <SensorViewFooter sensors={sensorData.Sensors} />
                        }
                        {
                            displayType === 'Device' && <DeviceViewFooter deviceData={sensorData.Device} deviceModel={vehicleDevice.vehicleInfo.dev_model} />
                        }
                        {
                            displayType === 'Security' && <SecurityViewFooter securityData={sensorData.Security} assetId={assetId} />
                        }
                    </Grid>
                </Grid>
            </Paper>
        );

    } else {
        return null;
    }

}

export default React.memo(AssetFooter);

